export default __webpack_public_path__ + "static/AI-Singapore-Story-19d5d4fc8a7ec7c4913ca373a6382be0.pdf";